import { Injectable } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { getComponentViewByInstance } from '@angular/core/src/render3/context_discovery';
import { BehaviorSubject } from 'rxjs';
import { DataAccessService } from '../../shared/services/dataaccess.service';



export class AcademicInstanceSchedule{
  PRNNo: string;
  StudentName: string;
  Gender:string;
  PhyDisability:string;
  ReDegree:string;
  ApplyForImprovement:string;
  CourseName:string;
  CoursePatternName:string;
  BranchName:string;
  CoursePartName:string;
  CollegeName:string;
  RequestID: string;
  RequestDate:string;
  TotalFeeAmount: string;
  Activity: string;
  SubjectData:Subjectlist[];
}


export class GridColumns {
  caption: string;
  dataField: string;
  width: number;
  dataType: string;
  cssClass: string;
  allowSorting: boolean;
};
export class GetCourse {
  CourseID :number;
  CourseName: string;
  CourseShortName: string;
};
export class columnSetting {
  RequestID: string;
  PRNNo: string;
  StudentName: string;
  TotalFeeAmount: number;
  ImprovementFlag: string;
  ApprovalFlag: string;
  ApprovalDate: string;
  ApprovalRemark: string;
};

export  class studentData {
  RequestID: string;
  PRNNo: string;
  StudentName: string;
  Gender:string;
  CourseName:string;
  CoursePatternName:string;
  BranchName:string;
  CoursePartName:string;
  CollegeName:string;
  RequestDate:string;
};

export class Subjectlist {
  SubjectId: number;
  SubName: string;
};
export class Formdatacolumns {
  AcademicInstance: string;
  StartDate: string;
  EndDate: string;
  EndDaApplicableToAllBrancheste: false;
  StudentType: string;
};
let Formdata: Formdatacolumns[] = [{
  AcademicInstance: "2018-2019",
  StartDate: "28-Feb-2019",
  EndDate: "28-Feb-2019",
  EndDaApplicableToAllBrancheste: false,
  StudentType:"Regular"
}]
let columnSettings: columnSetting[] = [{
  RequestID: "1",
  PRNNo: "123456789",
  StudentName: "Rabade Saurabh Deepak",
  TotalFeeAmount:1000,
  ImprovementFlag: "Y",
  ApprovalFlag: "Y",
  ApprovalDate: "04/Feb/2019",
  ApprovalRemark: "approval Successfully"
},
{
  RequestID:"2" ,
  PRNNo: "123456789",
  StudentName: "xyz",
  TotalFeeAmount:2000,
  ImprovementFlag: "N",
  ApprovalFlag: "N",
  ApprovalDate: "04/Feb/2019",
  ApprovalRemark: "Not Approval"
},
];

let studentInfoData: studentData[]=[{
  RequestID: "1",
  PRNNo: "123456789",
  StudentName: "Rabade Saurabh Deepak",
  Gender:"Male",
  CourseName:"Commerce",
  CoursePatternName:"Semister I",
  BranchName:"Commerce",
  CoursePartName:"No",
  CollegeName:"New College Kolhapur",
  RequestDate:"04/04/2019",



}];

let FeesData : Subjectlist[] = [{
  SubjectId: 1,
  SubName: "Physics"
},
{
  SubjectId: 2,
  SubName: "Chemistry"
}
];
let getCourseData: GetCourse[] = [{
  CourseID :1,
  CourseName: "Master Of Commerce",
  CourseShortName:  "Commerce"
},
{
  CourseID :2,
  CourseName: "Bachelor Of Arts",
  CourseShortName:  "Arts"
}
];
let courselist: string[] = [
  "Master Of Commerce",
  "Commerce "
];

let gridColumnsFees: GridColumns[] = [{
  "caption": 'Fees Name',
  "dataField": "FeesID",
  "width": 300,
  "dataType": "number",
  "cssClass": "",
  "allowSorting": false
},
{
  "caption": 'Amount',
  "dataField": "FeesAmount",
  "width": 200,
  "dataType": "number",
  "cssClass": "",
  "allowSorting": false
},
{
  "caption": 'Rep Fees Amount',
  "dataField": "RepFeesAmount",
  "width": 200,
  "dataType": "number",
  "cssClass": "",
  "allowSorting": false
}]
let gridColumns: GridColumns[] = [
{
  "caption": 'Request ID',
  "dataField": "RequestID",
  "width": 100,
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true
},
{
  "caption": 'PRN No.',
  "dataField": "PRNNo",
  "width": 100,
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true
},
{
  "caption": 'Student Name',
  "dataField": "StudentName",
  "width": 200,
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true
},
{
  "caption": 'Total Fee Amount',
  "dataField": "TotalFeeAmount",
  "width": 200,
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true
},
{
  "caption": 'Improvement Flag',
  "dataField": "ImprovementFlag",
  "width": 150,
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true
},
{
  "caption": 'Approval',
  "dataField": "ApprovalFlag",
  "width": 80,
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true
},
{
  "caption": 'Approval Date',
  "dataField": "ApprovalDate",
  "width": 150,
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true
},
{
  "caption": 'Approval Remark',
  "dataField": "ApprovalRemark",
  "width": 150,
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true
}
];
export class CourseProduct {
  CourseId: number;
  CourseName: string;
}


let Courseproducts: CourseProduct[] = [{
  "CourseId": 1,
  "CourseName": "Abc College"
}, {
  "CourseId": 2,
  "CourseName": "xyz College"
},
{
  "CourseId": 3,
  "CourseName": "New College Kolhapur"
}]
export class GenderProduct {
  GenderFlag: string;
  GenerName: String;
}
/* let Genderproducts: GenderProduct[] = [{
  "GenderFlag": "M",
  "GenerName": "Male"
}, {
  "GenderFlag":"F",
  "GenerName": "Female"
},
{
  "GenderFlag":"O",
  "GenerName": "Other"
}] */
let Genderproducts: string[] = [
  "Male",
  "Female",
];
let PhyDisabilityproducts: string[] = [
  "No",
  "Blind",
  "Handicaped"
];
let ReDegreeproducts: string[] = [
  "Yes",
  "No",
];
let ApplyForImprovementproducts: string[] = [
  "Yes",
  "No",
];
let CourseproductsNew: string[] = [
  "Abc College",
  "xyz College",
  "New College Kolhapur"
];
let CoursePatternProducts: string[] = [
  "Semister I",
  "Semister II",
];
let Branchproducts: string[] = [
  "Arts",
  "General",
];
export class FeesProduct {
  FeesId: number;
  FeesName: string;
}

let Feesproducts: FeesProduct[] = [{
  "FeesId": 1,
  "FeesName": "Exam Fee"
}, {
  "FeesId": 2,
  "FeesName": "Tution Fee"
},
{
  "FeesId": 3,
  "FeesName": "Convocation Fee"
},
{
  "FeesId": 4,
  "FeesName": "Other Fee"
}]
export class StudTypeProduct {
  StudTypeId: number;
  StudTypeName: string;
}
let StudTypeproducts: StudTypeProduct[] = [{
  "StudTypeId": 1,
  "StudTypeName": "Chemical Technology"
}, {
  "StudTypeId": 2,
  "StudTypeName": "Computer Science And Technology"
}];

 let getNewInstance: AcademicInstanceSchedule ={
  PRNNo: "" ,
  StudentName: "",
  Gender:"",
  PhyDisability:"",
  ReDegree:"",
  ApplyForImprovement:"",
  CourseName:"",
  CoursePatternName:"",
  BranchName:"",
  CoursePartName:"",
  CollegeName:"",
   RequestID: "",
  RequestDate:"",
  TotalFeeAmount: "",
  Activity: "",
  SubjectData:[{
      SubjectId:1 ,
      SubName: ""
    },
    {
      SubjectId: 1,
      SubName: ""
    }]
}
export class CollegeChange{
  CollegeChangeRequestID: number;
  StudentID: number;
  FormNo: string;
  RequestDate: string;
  ExamInstanceID: number;
  CoursePartID: number;
  BranchID: number;
  CollegeID: number;
  TransferCollegeID: number;
  ApplicationFees: number;
  ApplicationFeesReceivedDate: string;
  ApplicationDDNO: string;
  ApplicationBankName: string;
  ApplicationBankDDDate: string;
  CollegeChangeRemark:string;
  PaymentMode:string;
  ApplicationStatus: string;
  ApplicationDDConfirm: string;
  ApprovedFlag: string;
  ApprovalDate:string;
  ApprovalRemark: string;
  DeleteFlag: string;
  CreatedLoginID: number;
  UpdatedLoginID: number;
  
}
@Injectable({
  providedIn: 'root'
})
export class CollegechangeService {
    selectedAcademicInstance :AcademicInstanceSchedule;
    constructor(
      private dataService: DataAccessService) {
    }
    public GetCollegeChangeData(StudentID) {debugger
      this.dataService.setControllerName = '/PortalBranchChange/';
      this.dataService.setMethodName = 'GetDataForPortalBranchChangeByStudentID?StudentID='+ StudentID; // setting method name from API controller.
      return this.dataService.getAll<CollegeChange[]>()
    }
    public GetTransferredCollegeChangeData(CourseID,CollegeID) {debugger
      this.dataService.setControllerName = '/PortalCollegeChange/';
      this.dataService.setMethodName = 'GetCollegeForCollegeChange?CourseID='+CourseID+'&CollegeID='+CollegeID; // setting method name from API controller.
      return this.dataService.getAll<CollegeChange[]>()
    }
    public GetSequenceNO(Formnm) {debugger
      this.dataService.setControllerName = '/PortalBranchChange/';
      this.dataService.setMethodName = 'GetSequenceNO?Formnm='+ Formnm; // setting method name from API controller.
      return this.dataService.getAll<CollegeChange[]>()
    }
    public save(data) {debugger
      this.dataService.setControllerName = '/PortalCollegeChange/';
      this.dataService.setMethodName = 'PostInsertPortalCollegeChangeNEW'; // setting method name from API controller.
      return this.dataService.add<CollegeChange[]>(data) 
    }

    public GetDataforCollegeChangeList(StudentID,ExamInstanceID,AcademicInstanceID,CoursePartID) {debugger
      this.dataService.setControllerName = '/PortalCollegeChange/';
      this.dataService.setMethodName = 'GetDataforCollegeChangeList?StudentID='+ StudentID+'&ExamInstanceID='+ExamInstanceID+'&AcademicInstanceID='+AcademicInstanceID+'&CoursePartID='+CoursePartID; // setting method name from API controller.
      return this.dataService.getAll<CollegeChange[]>()
    }

    
  public CancelCollegeChangeApplication(RequestID,StudentID,AcademicInstanceID,ResultQueryCode) {
    this.dataService.setControllerName = '/PortalCollegeChange/';
    this.dataService.setMethodName = 'CancelCollegeChangeApplication?RequestID='+RequestID+'&StudentID='+StudentID+'&AcademicInstanceID='+AcademicInstanceID+'&ResultQueryCode='+ResultQueryCode+'';
    return this.dataService.getAll<CollegeChange[]>()
  }

  public GetUpdatePaymentStatusForCollegeChange(merchantTxnNo,ExamInstanceID,ApplicationNO,StudentID) {debugger
    this.dataService.setControllerName = '/Payment/';
    this.dataService.setMethodName = 'GetUpdatePaymentStatusForCollegeChange?merchantTxnNo='+ merchantTxnNo + '&ExamInstanceID='+ExamInstanceID+'&ApplicationNO='+ApplicationNO +'&StudentID='+StudentID; // setting method name from API controller.
    return this.dataService.getAll<CollegeChange[]>()
  }
  public CheckCollegeRequestStatusForNewRequest(StudentID,ExamInstanceID,CoursePartID) {debugger
    this.dataService.setControllerName = '/PortalCollegeChange/';
    this.dataService.setMethodName = 'CheckCollegeRequestStatusForNewRequest?StudentID='+ StudentID+'&ExamInstanceID='+ExamInstanceID+'&CoursePartID='+CoursePartID; // setting method name from API controller.
    return this.dataService.getAll<CollegeChange[]>()
  }

  public GetDocumentPathForCollegeChange(ApplicationNO,ExamInstanceID) {
    this.dataService.setControllerName = '/PortalCollegeChange/';
    this.dataService.setMethodName = 'GetDocumentPathForCollegeChange?ApplicationNO='+ApplicationNO+'&ExamInstanceID='+ExamInstanceID; // setting method name from API controller.
    return this.dataService.getAll<CollegeChange[]>()
  }
  public GetCollegeChangeReport(StudentID,ApplicationNO,ExamInstanceID) {
    this.dataService.setControllerName = '/FormPrintReportCertficatesRequest/';
    this.dataService.setMethodName = 'GetCollegeChangeReport?StudentID='+StudentID+'&ApplicationNO='+ApplicationNO+'&ExamInstanceID='+ExamInstanceID; // setting method name from API controller.
    return this.dataService.getAll<CollegeChange[]>()
  }
 getNewAcademicInstance(){
    return  getNewInstance;
  }

  setSelectedAcademicInstance(dataInstance:AcademicInstanceSchedule){
    this.selectedAcademicInstance=dataInstance;
  }
  getSelectedAcademicInstance(){
    return  this.selectedAcademicInstance ={
      PRNNo: " 12345613",
      StudentName: "xyz",
      Gender:"Male",
      PhyDisability:"No",
      ReDegree:"No",
      ApplyForImprovement:"No",
      CourseName:"Commerce",
      CoursePatternName:"Semister I",
      BranchName:"Arts",
      CoursePartName:"No",
      CollegeName:"New College Kolhapur",
      RequestID: "1",
      RequestDate:"05/Feb/2019",
      TotalFeeAmount: "1000",
      Activity: "Y",
      SubjectData:[{
          SubjectId: 1,
          SubName: "Physics"
        },
        {
          SubjectId: 2,
          SubName: "Chemistry"
        }]
    };
  }
  getGridColumnsData() {
    return columnSettings[0];
  }
  getGridColumns() {
    return gridColumns;
  }
  getGridColumnsFees(){
    return gridColumnsFees;
  }
  getCourse() {
    return getCourseData;
  }
   getData() {
    return columnSettings;
  }
  getDataForFees(){
    return FeesData;
  }
  getcourselist(){
    return courselist;
  }
  getCourseProducts() {
    return Courseproducts;
  }
  getFeesProducts() {
    return Feesproducts;
  }

  getDataForm() {
    return Formdata;
  }
  getStudTypeProducts(){
    return StudTypeproducts;
  }
  getGenderProducts() {
    return Genderproducts;
  }
  getPhyDisabilityProducts() {
    return PhyDisabilityproducts;
  }
  getReDegreeProducts() {
    return ReDegreeproducts;
  }
  getApplyForImprovementProducts() {
    return ApplyForImprovementproducts;
  }
  getCourseProductsNew() {
    return CourseproductsNew;
  }
  getCoursePatternProducts() {
    return CoursePatternProducts;
  }
  getBranchProducts() {
    return Branchproducts;
  }
  getstudentData(){
    return studentInfoData[0];
  }
}
